import React from 'react';
import { compose } from 'redux';
import { withAsync } from '@helpcenter/with-async';
import { useIntl } from 'react-intl';
import { lazyForPaint } from 'react-loosely-lazy';
import { withRouter, type Route } from 'react-resource-router';
import { withOnlyJiraAdmin } from 'view/common/with-only-jira-admin';
import { withOnlyLoggedIn } from 'view/common/with-only-logged-in';
import { authPageMessage, callToActionUrlText } from 'view/portal-reorder-experience';
import { AdminManagementLayout } from '@atlassian/admin-layout';
import { HelpCenterRovoServiceAgentResource } from '@atlassian/help-center-rovo-service-agent-settings/src/resource';

const AsyncRovoServiceAgentPage = withAsync({
    loader: lazyForPaint(() =>
        import(
            /* webpackChunkName: "async-help-center-rovo-service-agent-page" */ '@atlassian/help-center-rovo-service-agent-settings'
        ).then((module) => ({ default: module.RovoServiceAgentSettingsPageLoader }))
    ),
});

const RovoServiceAgentPage = () => {
    const { formatMessage } = useIntl();
    const WrappedComponent = compose(
        withOnlyLoggedIn({
            redirectUrl: '/',
        }),
        withOnlyJiraAdmin({
            message: formatMessage(authPageMessage),
            callToActionText: formatMessage(callToActionUrlText),
            callToActionUrl: '/portals',
        })
    )(() => (
        <AdminManagementLayout featureName="Rovo Service Agent Settings">
            <AsyncRovoServiceAgentPage />
        </AdminManagementLayout>
    ));
    return <WrappedComponent />;
};

export const helpcenterRovoServiceAgentRoute: Route = {
    name: 'rovoServiceAgentSettings',
    path: '/:helpcenterId/rovo-agent',
    exact: true,
    resources: [HelpCenterRovoServiceAgentResource],
    component: withRouter(RovoServiceAgentPage),
};
